import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type ModalFooterProps = {
  children?: React.ReactNode
  className?: string
}

export const ModalFooter = ({ children, className }: ModalFooterProps) => (
  <Styled.ModalFooter className={cc([className, reactClass('modal-footer')])}>{children}</Styled.ModalFooter>
)
